import { SvgIcon } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const ExpandIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 30 30">
            <path d="M18.3333 7H23M23 7V11.6667M23 7L17 13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.6667 23L7 23M7 23L7 18.3333M7 23L13 17" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}